export default __webpack_public_path__ + "static/media/fund_launch_logo_wide.e9ee128d.png";